import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    container: {
      spacing: 'space-y-2',
      variants: {
        'default': 'p-4 md:p-6',
        'full-width': 'p-4 md:p-6'
      }
    },
    buttons: 'pt-0'
  },
} satisfies CMSConfig['bannerEspot']
